import {Button, Modal} from "antd";
import React, {ComponentType, useContext, useState} from "react";
import {Navigate} from "react-router-dom";
import '../assets/css/Dentobook.css';
import {FormattedMessage} from "react-intl";
import DetailWrapper from "../components/common/DetailWrapper";
import {accessibilityRoles} from "../utils/accessUtils";
import AccessControl from "../components/common/AccessControl";
import {isMobileOnly} from "react-device-detect";
import {CloseOutlined} from "@ant-design/icons";
import {ExitPromptContext} from "../context/ExitPromptContext";
import {DentobookApplicationContext} from "../context/DentobookApplicationContext";
import { getPatientFormComponent, PatientFormData } from "../utils/patientUtils";
import {PatientFormProps} from "../components/patient/PatientForm";
import {tokenService} from "../services/tokenService";

const PatientCreate = () => {

    const {setFormDirty} = useContext(ExitPromptContext);

    const { userOrganization} = React.useContext(DentobookApplicationContext);

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const [goBack, setGoBack] = useState<boolean>(false);

    // Get organization ID directly from JWT (stateless, no race conditions)
    const organizationId = tokenService.getOrganizationIdFromToken();

    if (!organizationId) {
        return <Navigate to="/patients"/>;
    }

    const patient: PatientFormData = {
        firstName: '',
        lastName: '',
        organizationId: organizationId
    };

    const FormComponent: ComponentType<PatientFormProps> = getPatientFormComponent(userOrganization);

    const handleOk = () => {
        setFormDirty(false);
        setIsModalOpen(false);

        setGoBack(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    if (goBack) {
        return <Navigate to="/patients"/>
    }

    const footer = <div className="modal-btn-wrapper">
        <Button className="modal-btn" onClick={handleCancel}>
            {<FormattedMessage id="cancel"/>}
        </Button>
        <Button className="modal-btn" type="primary" onClick={handleOk}
        >
            {<FormattedMessage id="confirm"/>}
        </Button>
    </div>;

    return (
        <AccessControl notAccessibleFor={[accessibilityRoles.PLATFORM_ADMINISTRATOR, accessibilityRoles.PATIENT]}>
            <Modal
                transitionName=""
                footer={footer}
                className="dentobook-modal"
                title={<FormattedMessage id="add_patient"/>}
                closeIcon={<CloseOutlined className={'icon-24px'} onClick={handleCancel}/>}
                open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <h3 className={"dentobook-content font-weight-500 font-24 text-align-center " + (isMobileOnly ? "mt-112" : "")}><FormattedMessage id="unsaved_changes"/></h3>
            </Modal>
            <DetailWrapper navigateBack="/patients">
                <h2><FormattedMessage id="add_patient"/></h2>
                <FormComponent
                    setEditMode={() => {}}
                    mode={2}
                    openModal={() => setIsModalOpen(true)}
                    patient={patient}
                />
            </DetailWrapper>
        </AccessControl>
    );
};

export default PatientCreate;